var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import { Row, Col, Overlay, OverlayTrigger, Tooltip } from "react-bootstrap";
import QRCode from "qrcode.react";
import { ButtonLink } from "@irati/ui/src/Link";
import Hr from "@irati/ui/src/Layout/Hr";
import { FormattedMessage, FormattedDate, injectIntl } from "@irati/utils/lang";
import tracking from "@irati-tracking/perks/perks";
import id from "@irati/utils/id";
import isTimeLimited from "@irati/deals/helpers/deals/isTimeLimited";
import StockType from "@irati/stock/enums/StockType";
import { Label } from "@irati/ui/src/Typography";
import LabelValue from "./LabelValue";
import CopyButton from "./CopyButton";
import ProductCode from "./styled/ProductCode";
import QrContainer from "./styled/QrContainer";
import TicketContainer from "./styled/TicketContainer";
import { StyledTooltip, Pin } from "./styled/Code";
var TicketCode = /** @class */ (function (_super) {
    __extends(TicketCode, _super);
    function TicketCode(props) {
        var _this = _super.call(this, props) || this;
        _this.copyToolTipProps = function () {
            return {
                show: _this.state.showCopyTooltip,
                target: function () { return _this.codeRef.current; }
            };
        };
        _this.handleCopy = function () {
            tracking.redeemPerkCopyCode(_this.props.voucher.deal);
            _this.setState({ showCopyTooltip: true });
            setTimeout(function () {
                _this.setState({ showCopyTooltip: false });
            }, 2000);
        };
        _this.voucherTooltip = function () { return (React.createElement(StyledTooltip, { id: "voucher", placement: "bottom" }, _this.props.voucher.code)); };
        _this.codeRef = React.createRef();
        _this.state = {
            showCopyTooltip: false
        };
        return _this;
    }
    /**
     * @author: Matthew Rawson @ 08/09/2017 14:12
     * @notes: `<QRCode value={code} size={600} />` setting a size to 600px creates the canvas image to that size.
     * This is so it looks good when scaling. QrCol is overriding how it is displayed on the page (responsivly scaling).
     * @returns {XML}
     */
    TicketCode.prototype.render = function () {
        var _a = this.props, voucher = _a.voucher, url = _a.url, formatMessage = _a.formatMessage;
        var _b = this.props.voucher, expiry = _b.expiry, pin = _b.pin, code = _b.code, product = _b.product, type = _b.type, deal = _b.deal;
        var isQrCode = type === StockType.QR;
        return (React.createElement(TicketContainer, { id: id("code", this.props) },
            isQrCode && (React.createElement(QrContainer, null,
                React.createElement(QRCode, { value: code, size: 600 }))),
            React.createElement(Label, { display: "inline-block", marginBottom: 1 }, product.name),
            React.createElement(OverlayTrigger, { placement: "bottom", overlay: this.voucherTooltip() },
                React.createElement(ProductCode, { isQrCode: isQrCode, onClick: function () { return tracking.redeemPerkCopyCode(deal); }, ref: this.codeRef }, code)),
            React.createElement(Overlay, __assign({}, this.copyToolTipProps(), { placement: "bottom" }),
                React.createElement(Tooltip, { id: "copiedToClipboard", positionLeft: 0 },
                    React.createElement(FormattedMessage, { id: "perks.components.tickets.ticket.code.copied" }))),
            pin && React.createElement(Pin, { value: pin, label: formatMessage({ id: "perks.components.tickets.ticket.code.PIN" }) }),
            expiry && !isTimeLimited(deal) && (React.createElement(LabelValue, { value: React.createElement(FormattedDate, { value: expiry, year: "numeric", month: "2-digit", day: "numeric" }), label: formatMessage({ id: "perks.components.tickets.ticket.code.expDate" }) })),
            React.createElement(Hr, null),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12, md: url ? 6 : 12 },
                    React.createElement(CopyButton, { voucher: voucher, onCopy: this.handleCopy })),
                url && (React.createElement(Col, { xs: 12, md: 6 },
                    React.createElement(ButtonLink, { href: url, primary: true, full: true, target: "_blank", onClick: function () { return tracking.redeemPerkFollowLink(deal); } },
                        React.createElement(FormattedMessage, { id: "perks.components.tickets.ticket.url.open" })))))));
    };
    return TicketCode;
}(Component));
export default injectIntl(TicketCode);
